import React, { Fragment } from "react";
import InfoBlock from "../presentational/InfoBlock";

const AboutContainer = () => {
    const info = [
        {
            title: "\"От идеята до крайното изделие!\"",
            text:
                "Формопласт следва своето мото всеки ден от своята 34-годишна история. То се изразява в процеса на изработка на дизайна на изделието,  начертаването на технологичния маршрут,  машинната обработка, събирането, напасването и окончателното изпитание на готовите."
        },
        {
            title: "ШПРИЦФОРМИ ЗА ПЛАСТМАСА",
            text:
                "Във фирмата работи високо-специализиран екип от млади хора, които използват \"VISI CAD/CAM\" за разработката на дизайна,  конструирането на шприцформите и програмното осигуряване на машините с CNC. \n Фирмата разполага с голям и разнообразен машинен парк от: CNC/NC фрези FKrS 500x1500, SHW, MAHO 800E, PB 450x1200, DECKEL -NC борверзи BFT 80/2. 90/3, 130/6, -Шлайфмашини KELENBERGER, DECKEL –LKS, CNC DOEBELLI – OP150, -Координатно-разстъргващи машини, -Универсални и CNC стругове, -Ерозийни машини – AGIETRON -EMS 2.20, 3.30, AGIEMAT – 3R, etc. \n Фирмата е специализирана в производството на голямогабаритни инструменти за твърди пластмасови опаковки - каси и касети за промишлеността, транспорта и селското стопанство, пластмасови изделия за бита, технически части и т.н., както и в производството на собствени пластмасови изделия. \n Формопласт е сертифициран по ISO 9001:2000. \n Нашите шприцформи са познати на три континента - Европа, Азия и Африка."
        },
        {
            title: "ПОЛИТИКА ПО КАЧЕСТВОТО",
            href: 'https://formoplastbg.com/Bg/News_files/qualitypolicy.pdf',
            text:
                "Aдрес: Формопласт АД, Промишлена зона юг, 6600 Кърджали, България"
        }
    ];

    return (
        <Fragment>
            {info.map(({ title, text, href }) => (
                <InfoBlock key={title} title={title} href={href}>
                    <p style={{ whiteSpace: 'pre-line' }}>{text} </p>
                </InfoBlock>
            ))}
        </Fragment>
    );
}

export default AboutContainer;
